import { Component } from '@angular/core';

@Component({
  selector: 'apex-delete-dialog',
  templateUrl: './delete-dialog.component.html',
})
export class DeleteDialogComponent {
  checky = false;
}
